module.exports = __webpack_public_path__ + "img/cielo-logo.92d91219.svg";